export function openRegistrationForm() {
  const registrationPageLink = "https://lassie.ru/auth/?back_url=/detiolete/";
  window.location = registrationPageLink;
}
